// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1906e508] .right-aligned-input input{text-align:right}@media only screen and (max-width:959px){[data-v-1906e508] .v-input__slot.white .v-text-field__slot{align-items:center!important;display:flex!important;margin-top:2px;min-height:44px!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
